var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBinLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 8h6.667v2.667h-2.667V28a1.333 1.333 0 0 1-1.333 1.334H6.667A1.333 1.333 0 0 1 5.334 28V10.667H2.667V8h6.667V4a1.333 1.333 0 0 1 1.333-1.333h10.667A1.333 1.333 0 0 1 22.667 4v4zM24 10.667H8v16h16v-16zm-12 4h2.667v8H12v-8zm5.334 0H20v8h-2.666v-8zM12 5.334V8h8V5.334h-8z",
    fill: "#FEFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBinLine);
export default __webpack_public_path__ + "static/media/delete-bin-line.73cf359d0574a1512878b6205f1f9bf5.svg";
export { ForwardRef as ReactComponent };